<template>
  <div class="maks">
    <div class="feedback-form">
      <div class="form-top">
        <span>意见反馈</span>
        <span
          @click="isFeedbackHide()"
          class="close-mark"
          style="cursor: pointer"
        ></span>
      </div>
      <div class="form-content" v-if="successSubmit">
        <div class="category">
          <div class="category-left">反馈类别</div>
          <div class="category-right">
            <select name="" id="" v-model="category">
              <option
                :value="item.value"
                v-for="(item, index) in list"
                :key="index"
              >
                {{ item.feedbackCategory }}
              </option>
            </select>
          </div>
        </div>
        <input
          type="text"
          placeholder="请描述意见场景或者网页地址"
          v-model="feedbackTitle"
          :class="feedbackTitleFlag ? 'active feedbackOrUrl' : 'feedbackOrUrl'"
          @focus="checkFeedTitleFlag()"
        />
        <textarea
          name=""
          id=""
          placeholder="请详细描述您的意见"
          :class="feedbackContentFlag ? 'active feedbackText' : 'feedbackText'"
          v-model="feedbackContent"
          @focus="checkFeedContentFlag()"
        >
        </textarea>
        <div class="phone">
          <div
            :class="
              contractDetailFlag ? 'activePhone phone-cont' : 'phone-cont'
            "
          >
            <div class="phone-left">手机号</div>
            <div class="phone-right">
              <input
                type="number"
                :placeholder="phonePlaceholder"
                v-model="contractDetail"
                @focus="checkContractDetailFlag()"
              />
            </div>
          </div>
          <div class="answer-visit">
            <input type="checkbox" checked v-model="contractFlag" />
            <span>愿意接受回访</span>
          </div>
        </div>
        <div class="upimg">
          <fileImg :imgList.sync="imgList" @imgData="upImglist"></fileImg>
          <span class="tips"
            >*支持jpg、png、gif、bmp格式的图片，可上传5张，单张最大5M</span
          >
        </div>
        <button @click="submit()">提交</button>
      </div>
      <div class="leave-word" v-else>
        <div class="leave-title">留言成功</div>
        <div class="leave-content">我们会尽快联系你</div>
        <button @click="close()">关闭</button>
      </div>
    </div>
  </div>
</template>
<script>
import fileImg from "../components/fileImg";
import { setFeedback } from "../api/open/passport";
export default {
  name: "feedback",
  components: {
    fileImg,
  },
  data() {
    return {
      list: [
        {
          feedbackCategory: "请选择意见反馈类别",
          value: "请选择意见反馈类别",
        },
        {
          feedbackCategory: "使用遇到问题",
          value: "使用遇到问题",
        },
        {
          feedbackCategory: "投诉与建议",
          value: "投诉与建议",
        },
        {
          feedbackCategory: "合作意向",
          value: "合作意向",
        },
        {
          feedbackCategory: "其他",
          value: "其他",
        },
      ],
      category: "请选择意见反馈类别", //反馈类型
      feedbackTitle: "", //反馈标题
      feedbackContent: "", //反馈内容
      contractDetail: "", //手机号
      contractFlag: true, //是否接受回访
      feedbackContentFlag: false,
      contractDetailFlag: false,
      feedbackTitleFlag: false,
      phonePlaceholder: "请填写联系手机号",
      //图片
      imgList: [],
      successSubmit: true,
    };
  },
  methods: {
    // 获取上传图片
    upImglist(val) {
      this.imgList = val;
    },
    // 点击X号隐藏
    isFeedbackHide() {
      this.$emit("isFeedback");
    },
    // 标题提示
    checkFeedTitleFlag() {
      this.feedbackTitleFlag = false;
    },
    // 内容提示
    checkFeedContentFlag() {
      this.feedbackContentFlag = false;
    },
    // 手机号提示
    checkContractDetailFlag() {
      this.contractDetailFlag = false;
      this.phonePlaceholder = "请填写联系手机号";
    },
    // 提交
    submit() {
      let category = "";
      if (this.category == "请选择意见反馈类别") {
        category = "使用遇到问题";
      } else {
        category = this.category;
      }
      if (!this.feedbackTitle) {
        this.feedbackTitleFlag = true;
        return;
      }
      if (!this.feedbackContent) {
        this.feedbackContentFlag = true;
        return;
      }
      if (!this.contractDetail) {
        this.contractDetailFlag = true;
        this.phonePlaceholder = "手机号必填";
        return;
      }
      if (this.imgList) {
        this.imgList = this.imgList.join(",");
      }
      let para = {
        feedbackType: category,
        feedbackTitle: this.feedbackTitle,
        feedbackContent: this.feedbackContent,
        contractDetail: this.contractDetail,
        contractFlag: this.contractFlag,
        images: this.imgList,
      };
      setFeedback(para).then((res) => {
        if (res.data.code == "000") {
          this.successSubmit = false;
        }
      });
    },
    close() {
      document.documentElement.style.height = 100 + "%";
      document.documentElement.style.overflow = "auto";
      this.$store.commit("UPSTATAFEEDBACK", false);
    },
  },
};
</script>
<style lang="scss" scoped>
.maks {
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.3);
}
.feedback-form {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  width: 560px;
  height: 650px;
  border-radius: 6px;
  font-size: 14px;
  background-color: rgb(245, 245, 245);
  overflow: hidden;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  // margin: 30px auto;
  .content-main {
    background-color: white;
  }
  .form-top {
    box-sizing: border-box;
    width: 100%;
    height: 40px;
    font-size: 16px;
    background-color: #2d74fd;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px 0 20px;
    .close-mark {
      display: block;
      width: 14px;
      height: 14px;
      background-color: red;
      background: url("../assets/images/icon/close.png");
      background-size: cover;
    }
  }
  .form-content {
    width: 460px;
    height: 600px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    .category {
      box-sizing: border-box;
      width: 100%;
      height: 30px;
      display: flex;
      align-items: center;
      border-radius: 8px;
      overflow: hidden;
      .category-left {
        width: 80px;
        color: rgb(75, 75, 75);
        text-align: left;
      }
      .category-right {
        flex: 1;
        select {
          box-sizing: border-box;
          width: 100%;
          height: 30px;
          font-size: 14px;
          vertical-align: top;
          border: 1px solid rgb(242, 243, 245);
          padding-left: 10px;
          border-radius: 0 8px 8px 0;
          background-color: white;
          outline: none;
        }
      }
    }
    .feedbackOrUrl {
      box-sizing: border-box;
      width: 100%;
      height: 30px;
      font-size: 14px;
      border: 1px solid rgb(242, 243, 245);
      border-radius: 8px;
      padding-left: 10px;
      &::placeholder {
        font-size: 14px;
      }
    }
    .feedbackText {
      box-sizing: border-box;
      width: 100%;
      height: 200px;
      font-size: 14px;
      border: 1px solid rgb(242, 243, 245);
      border-radius: 8px;
      padding: 4px 10px;
      &::placeholder {
        font-size: 14px;
      }
    }
    .phone {
      width: 100%;
      height: 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .phone-cont {
        display: flex;
        overflow: hidden;
        border-radius: 8px;
        border: 1px solid rgb(242, 243, 245);
        .phone-left {
          width: 60px;
          color: rgb(75, 75, 75);
          // background-color: #adadad;
          text-align: left;
        }
        .phone-right {
          width: 200px;
          font-size: 14px;
          background-color: white;
          //   border: 1px solid #999;
          border-radius: 0 8px 8px 0;
          padding-left: 10px;
          input {
            font-size: 14px;
            height: 30px;
            &::placeholder {
              font-size: 14px;
            }
          }
        }
      }
      .answer-visit {
        display: flex;
        align-items: center;
        justify-content: center;
        span {
          color: rgb(75, 75, 75);
          margin-left: 10px;
        }
      }
    }
    .tips {
      color: rgba(153, 153, 153, 0.5);
      font-size: 12px;
    }
    button {
      width: 100%;
      height: 40px;
      color: white;
      font-size: 16px;
      border-radius: 8px;
      background-color: #2d74fd;
    }
    .active {
      border: 1px solid red !important;
    }
    .activePhone {
      border: 1px solid red !important;
      input::placeholder {
        color: red;
      }
    }
  }
  .leave-word {
    width: 100%;
    height: 70%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: black;
    .leave-title {
      width: 300px;
      text-align: center;
      color: black;
      padding: 10px 0;
      border-radius: 8px;
      font-weight: 800;
      font-size: 20px;
    }
    button {
      width: 300px;
      height: 40px;
      color: white;
      font-size: 16px;
      background-color: #2d74fd;
      border-radius: 8px;
      padding: 10px 0;
    }
  }
}
</style>
